module.exports = __webpack_public_path__ + "img/aurora.b931c6fd.svg";